import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import { useTranslation } from '../../i18n/LanguageProvider';

const propTypes = {
  ...SectionSplitProps.types
};

const defaultProps = {
  ...SectionSplitProps.defaults
};

const splitImages = [
  {
    src: require('./../../assets/images/features-split-image-01.png'),
    alt: 'Features split 01'
  },
  {
    src: require('./../../assets/images/features-split-image-02.png'),
    alt: 'Features split 02'
  },
  {
    src: require('./../../assets/images/features-split-image-03.png'),
    alt: 'Features split 03'
  }
];

const FeaturesSplit = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {
  const { t } = useTranslation();

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = t('featuresSplit.header');
  const items = t('featuresSplit.items');

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>
            {items.map((item, index) => {
              const revealDirection = index % 2 === 0 ? 'reveal-from-left' : 'reveal-from-right';
              const image = splitImages[index] || splitImages[0];

              return (
                <div className="split-item" key={item.title}>
                  <div className={`split-item-content center-content-mobile ${revealDirection}`} data-reveal-container=".split-item">
                    <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                      {item.eyebrow}
                    </div>
                    <h3 className="mt-0 mb-12">
                      {item.title}
                    </h3>
                    <p className="m-0">
                      {item.description}
                    </p>
                  </div>
                  <div
                    className={classNames(
                      'split-item-image center-content-mobile reveal-from-bottom',
                      imageFill && 'split-item-image-fill'
                    )}
                    data-reveal-container=".split-item">
                    <Image
                      src={image.src}
                      alt={image.alt}
                      width={528}
                      height={396} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;
